module.exports = __webpack_public_path__ + "img/add.6755eaed.svg";